module.exports = __webpack_public_path__ + "img/Diversity.db67a18f.png";